import { lazy as lazyLoad } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lazy = (resolver: any, name = 'default') => {
	return lazyLoad(async () => {
		const resolved = await resolver();
		return { default: resolved[name] };
	});
};
